import React, { FC } from 'react'
import dynamic from 'next/dynamic'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useCookies } from 'react-cookie'
import { toggleCustomizeModal } from 'src/redux/nlt-offer/actions'
import { useBreakpointValue } from '@chakra-ui/react'

const StickyBar = dynamic(() => import('../components/Sticky/Bar'))

interface Props {
  offerData: OfferGlobal.RentOfferDetail
  visible: boolean
}

const StickyBarContainer: FC<Props> = ({ offerData, visible }) => {
  const { t } = useTranslation()
  const isMobile = useBreakpointValue({ base: true, md: false })
  const dispatch = useDispatch()
  const [, setCookie, removeCookie] = useCookies()
  const userProfile = useSelector((state: Store.RootState) => state.user?.profile)
  const priceVatIncluded = useSelector((state: Store.RootState) => state.nlt.priceVatIncluded)

  const openCustomizeModal = step => {
    if (step > 0) {
      setCookie('hideStep0', '1', { path: '/' })
    } else {
      removeCookie('hideStep0', { path: '/' })
    }

    dispatch(toggleCustomizeModal({ step }))
  }

  let modalStepToPreconfigured: number = 1;
  let modalStepToCustom: number = 0;

  if (userProfile && userProfile.id) { // utente riconosciuto, deve solo ri-confermare i propri dati
    modalStepToPreconfigured = 2
    modalStepToCustom = 2
  } else if (userProfile && userProfile.deal) { // configurazione offerta preesistente, vai al chatbot
    modalStepToPreconfigured = 3
    modalStepToCustom = 3
  }

  const primaryButton = {
    title: t('offerContainer:primaryTitle', { value: `${offerData.vehicle.brand} ${offerData.vehicle.model}` }),
    action: isMobile ? t('offerContainer:primaryActionStickyMobile') : t('offerContainer:primaryActionSticky'),
    onClick: () => openCustomizeModal(modalStepToPreconfigured),
  }
  const secondaryButton = {
    title: t('offerContainer:secondaryTitle', { value: `${offerData.vehicle.brand} ${offerData.vehicle.model}` }),
    action: t('offerContainer:secondaryActionSticky'),
    onClick: () => openCustomizeModal(modalStepToCustom),
  }

  const expirationValue = offerData.expirationDate ? t('nltOffersComponent:badge', {
    value: Math.floor(((new Date()).getTime() - Date.parse(offerData.expirationDate)) / (24 * 60 * 60 * 1000))
  }) : null

  const priceValue = priceVatIncluded ? Math.round(offerData.monthlyRate * 1.22) : offerData.monthlyRate
  const priceDescription = priceVatIncluded ? t('offerContainer:priceDescriptionVatIncluded') : t('offerContainer:priceDescription')
  const depositValue = offerData.deposit ?
    priceVatIncluded ? Math.round(offerData.deposit * 1.22) : offerData.deposit
    : 0
  const depositDescription = priceVatIncluded ? t('offerContainer:depositDescriptionVatIncluded') : t('offerContainer:depositDescription')

  return <StickyBar
    sectionTitle={`${offerData.vehicle.brand} ${offerData.vehicle.model}`}
    subtitle={offerData.vehicle.version}
    priceValue={t('offerContainer:priceValue', { value: priceValue.toLocaleString('it-IT') })}
    priceDescription={priceDescription}
    durationTitle={t('offerContainer:durationTitle')}
    durationValue={t('offerContainer:durationValue', { value: offerData.contractLength.toLocaleString('it-IT') })}
    distanceTitle={t('offerContainer:distanceTitleShort')}
    distanceValue={t('offerContainer:distanceValue', { value: offerData.annualMileage == 0 ? 'illimitati' : offerData.annualMileage.toLocaleString('it-IT') })}
    depositTitle={t('offerContainer:depositTitle')}
    depositValue={depositValue ? t('offerContainer:depositValue', { value: depositValue.toLocaleString('it-IT') }) : t('offerContainer:depositValueZero')}
    depositDescription={depositValue ? depositDescription : ''}
    expirationValue={expirationValue}
    visible={visible}
    active={offerData.status}
    primary={primaryButton}
    hasSecondaryAction={offerData.variations.length > 0}
    secondary={secondaryButton}
  />
}

export default StickyBarContainer
